import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueSweetalert2 from 'vue-sweetalert2'
import auth from '@/auth'
import 'sweetalert2/dist/sweetalert2.min.css'
import '@/assets/css/fonts.css'

Vue.use(VueSweetalert2)

Vue.config.productionTip = false

Vue.use(auth)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
